import type { Translations } from "./it";

export const en: Translations = {
  // Navigation
  nav: {
    home: "Home",
    gallery: "Gallery",
    landscapes: "Landscapes",
    portraits: "Portraits",
    abstract: "Abstract",
    about: "About",
    contact: "Contact",
    shop: "Shop",
    shopAll: "Shop all",
    print: "Print",
    original: "Original",
    cart: "Cart",
    admin: "Admin",
    myOrders: "My Orders",
    login: "Sign In",
    logout: "Sign Out",
    account: "Account",
  },

  // Home page
  home: {
    heroTitle: "Art that tells stories",
    heroSubtitle: "Art for lived-in spaces.",
    heroCta: "Shop all",
    categoriesTitle: "Shop",
    categoriesSubtitle: "Explore by category",
    featuredTitle: "Featured Works",
    featuredSubtitle: "Selected for you",
    viewAll: "View All",
    aboutTitle: "The Artist",
    aboutText: "Every brushstroke tells a story. Discover the world of Dalila Di Maria through her original works.",
    aboutCta: "Learn More",
  },

  // Categories
  categories: {
    print: "Print",
    printDesc: "Art prints for every space",
    original: "Original",
    originalDesc: "One-of-a-kind hand-painted works",
    landscapes: "Landscapes",
    landscapesDesc: "The beauty of nature captured on canvas",
    portraits: "Portraits",
    portraitsDesc: "The soul of people through colour",
    abstract: "Abstract",
    abstractDesc: "Emotions and forms beyond reality",
  },

  // Product/Artwork
  artwork: {
    price: "Price",
    technique: "Technique",
    dimensions: "Dimensions",
    year: "Year",
    category: "Category",
    available: "Available",
    sold: "Sold",
    reserved: "Reserved",
    addToCart: "Purchase",
    buyNow: "Buy Now",
    inquire: "Inquire",
    relatedWorks: "Related Works",
    details: "Details",
    shipping: "Shipping",
    shippingInfo: "Insured worldwide shipping. The artwork is carefully professionally packaged.",
  },

  // Cart & Checkout
  cart: {
    title: "Your Cart",
    empty: "Your cart is empty",
    continueShopping: "Continue Exploring",
    subtotal: "Subtotal",
    shipping: "Shipping",
    total: "Total",
    checkout: "Proceed to Payment",
    remove: "Remove",
  },

  // Checkout
  checkout: {
    title: "Payment",
    customerInfo: "Contact Information",
    name: "Full Name",
    email: "Email",
    phone: "Phone",
    shippingAddress: "Shipping Address",
    address: "Address",
    city: "City",
    postalCode: "Postal Code",
    country: "Country",
    notes: "Notes (optional)",
    pay: "Pay Now",
    processing: "Processing...",
    secure: "Secure payment with Stripe",
  },

  // Contact
  contact: {
    title: "Get in Touch",
    subtitle: "Have questions about a piece or want to commission a custom work?",
    name: "Name",
    email: "Email",
    subject: "Subject",
    message: "Message",
    send: "Send Message",
    success: "Message sent successfully! I'll get back to you soon.",
    error: "Error sending message. Please try again.",
  },

  // About
  about: {
    title: "About",
    subtitle: "Dalila Di Maria",
    bio: "I am an Italian artist passionate about painting. Each of my works is born from an emotion, a memory, or a landscape that struck me. I work primarily with oil and acrylic on canvas, seeking to capture the light and atmospheres that make every moment unique.",
    studioTitle: "My Studio",
    processTitle: "My Creative Process",
    commissionsTitle: "Commissions",
    commissionsText: "I accept commissions for custom works. Contact me to discuss your idea.",
    commissionsCta: "Request a Commission",
  },

  // Auth
  auth: {
    login: "Sign In",
    register: "Sign Up",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    forgotPassword: "Forgot Password?",
    loginWithGoogle: "Sign in with Google",
    loginWithEmail: "Sign in with Email",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    createAccount: "Create Account",
    collectorSignIn: "Collector sign in",
    createCollectorAccount: "Create collector account",
    accountDescription: "Use your account to save checkout details and manage orders from the Dalila studio.",
  },

  // Account
  account: {
    title: "My Account",
    subtitle: "Manage your profile and view your orders from the Dalila studio.",
    welcome: "Welcome",
    roleUser: "Collector",
    roleAdmin: "Administrator",
    profile: "Profile",
    name: "Name",
    email: "Email",
    orders: "My Orders",
    ordersEmpty: "You don't have any orders yet.",
    orderNumber: "Order no.",
    adminPanel: "Admin Panel",
    logout: "Sign Out",
  },

  // Footer
  footer: {
    rights: "All rights reserved",
    privacy: "Privacy",
    terms: "Terms & Conditions",
    followMe: "Follow Me",
    newsletter: "Newsletter",
    newsletterText: "Subscribe to receive updates on new works",
    subscribe: "Subscribe",
    emailPlaceholder: "Your email",
  },

  // Common
  common: {
    loading: "Loading...",
    error: "An error occurred",
    retry: "Retry",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    close: "Close",
    search: "Search",
    filter: "Filter",
    sortBy: "Sort by",
    noResults: "No results",
    viewMore: "View More",
    backToHome: "Back to Home",
  },

  // Order confirmation
  orderConfirmation: {
    title: "Order Confirmed!",
    subtitle: "Thank you for your purchase",
    orderNumber: "Order Number",
    emailSent: "We've sent you a confirmation email.",
    continueShopping: "Continue Exploring",
  },
} as const;
